<template>
  <sa-page-layout :btnBackVisible="false" :btnNewVisible="false" :btnRefreshVisible="true" :showModalLoading="showModalLoading" @refresh="onRefresh">
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col xs="12" sm="12" md="6" lg="5" xl="5">
            <label class="sa-label-data">Descrizione Magazzino</label>
            <b-form-input v-model="filtroMagazzino.descrizioneMagazzino" type="search" placeholder="Inserire Descrizione Magazzino"></b-form-input>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="5" xl="5">
            <label class="sa-label-data">Codice Magazzino</label>
            <b-form-input v-model="filtroMagazzino.codiceMagazzino" type="search" placeholder="Inserire Codice Magazzino"></b-form-input>
          </b-col>
          <b-col xs="12" sm="12" md="2" lg="2" xl="2">
            <label class="sa-label-data">Tipo Magazzino</label>
            <b-form-select v-model="filtroMagazzino.tipo" type="search" :options="magazzinoTipoOptions" text-field="descrizione" value-field="descrizione">
              <template #first>
                <b-form-select-option :value="null"> TUTTI </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row style="margin-top: 5px">
          <b-col class="sa-padding-right text-right mb-3">
            <b-button type="submit" variant="info">{{ this.$i18n.t("global.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-body">
      <magazzino-magazzini-list-component ref="cmpMagazzinoMagazziniListComponent" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></magazzino-magazzini-list-component>
    </template>
  </sa-page-layout>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import MagazzinoMagazziniListComponent from "../components/MagazzinoMagazziniListComponent.vue";
import MagazzinoTipoMixins from "../mixins/MagazzinoTipoMixins";

export default {
  name: "MagazzinoMagazziniListPage",
  mixins: [UtilityMixin, MagazzinoTipoMixins],
  components: { SaPageLayout, MagazzinoMagazziniListComponent },
  data() {
    return {
      showModalLoading: false,
      filtroMagazzino: {
        descrizioneMagazzino: null,
        codiceMagazzino: null,
        tipo: null,
      },
      pathResourceTipologiaMagazzino: "/magazzinotipo",
      pathResourceTipiArticolo: "/magazzino",
    };
  },
  /* */
  mounted() {
    let me = this;
    me.loadMagazzini();
    me.loadResourceMagazzinoTipo();
  },

  methods: {
    onRefresh() {
      this.$refs.cmpMagazzinoMagazziniListComponent.init(this.filtroMagazzino);
    },
    loadMagazzini() {
      if (this.$refs.cmpMagazzinoMagazziniListComponent) {
        this.$refs.cmpMagazzinoMagazziniListComponent.init(this.filtroMagazzino);
      }
    },
    onSubmit() {
      if (this.$refs.cmpMagazzinoMagazziniListComponent) {
        this.$refs.cmpMagazzinoMagazziniListComponent.init(this.filtroMagazzino);
      }
    },
    onReset() {
      this.filtroMagazzino = {
        descrizioneMagazzino: null,
        codiceMagazzino: null,
      };
      this.onSubmit();
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
  },
};
</script>

<style></style>
